import CartItem, { isProductCartItem } from './CartItem';

export default function isDirtyCartItem(item: CartItem) {
  return isProductCartItem(item) && item.amount !== item.originalAmount;
}
